import type { MouseEvent } from "react";
import { MessageTypes } from "../enums/MessageTypes";
import { messagesStore } from "../store/Messages";

const TELEGRAM_HOSTS = new Set(["t.me", "telegram.me", "telegram.dog"]);

const VPN_HINT = "Чтобы открыть ссылку, нужен VPN";
const CHECK_DELAY_MS = 2800;

export function isTelegramUrl(url: string): boolean {
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    return TELEGRAM_HOSTS.has(host);
  } catch {
    return false;
  }
}

export function isMobileDevice(): boolean {
  if (typeof navigator === "undefined") return false;

  return (
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 &&
      window.matchMedia("(max-width: 1024px)").matches)
  );
}

function navigateToUrl(url: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function showVpnHint(): void {
  messagesStore.add({
    text: VPN_HINT,
    type: MessageTypes.warning,
    durationMs: 12000,
  });
}

/** Открывает Telegram-ссылку и на мобильных показывает подсказку про VPN, если переход не удался. */
export function openTelegramLink(url: string): void {
  if (!isTelegramUrl(url)) {
    navigateToUrl(url);
    return;
  }

  if (!isMobileDevice()) {
    navigateToUrl(url);
    return;
  }

  let leftPage = false;

  const markLeftPage = () => {
    leftPage = true;
  };

  const onVisibilityChange = () => {
    if (document.hidden) markLeftPage();
  };

  window.addEventListener("blur", markLeftPage);
  window.addEventListener("pagehide", markLeftPage);
  document.addEventListener("visibilitychange", onVisibilityChange);

  const cleanup = () => {
    window.removeEventListener("blur", markLeftPage);
    window.removeEventListener("pagehide", markLeftPage);
    document.removeEventListener("visibilitychange", onVisibilityChange);
  };

  navigateToUrl(url);

  window.setTimeout(() => {
    cleanup();
    if (!leftPage && document.visibilityState === "visible") {
      showVpnHint();
    }
  }, CHECK_DELAY_MS);
}

export function handleTelegramLinkClick(
  event: MouseEvent<HTMLAnchorElement>,
  url: string,
): void {
  if (!isTelegramUrl(url) || !isMobileDevice()) return;

  event.preventDefault();
  openTelegramLink(url);
}
